/*
Monthly 2.2.2 by Kevin Thornbloom is licensed under a Creative Commons Attribution-ShareAlike 4.0 International License.
*/

let changeDate = true;
let allData;

(function ($) {
	let firstLoad = false;
	"use strict";
	$.fn.extend({
		monthly: function(customOptions) {
			var url = new URL(window.location.href);
			var cdate = url.searchParams.get("date");

			// These are overridden by options declared in footer
			var defaults = {
				dataType: "xml",
				disablePast: false,
				eventList: true,
				events: "",
				jsonUrl: "",
				linkCalendarToEventUrl: false,
				maxWidth: false,
				mode: "event",
				setWidth: false,
				showTrigger: "",
				startHidden: false,
				stylePast: false,
				target: "",
				useIsoDateFormat: false,
				weekStart: 1,	// Sunday
				xmlUrl: ""
			};

			var	options = $.extend(defaults, customOptions),
				uniqueId = $(this).attr("id"),
				parent = "#" + uniqueId,
				currentDate = new Date(),
				currentMonth = currentDate.getMonth() + 1,
				currentYear = currentDate.getFullYear(),
				currentDay = currentDate.getDate(),
				locale = (options.locale || defaultLocale()).toLowerCase(),
				monthNameFormat = options.monthNameFormat || "short",
				weekdayNameFormat = options.weekdayNameFormat || "short",
				monthNames = options.monthNames || defaultMonthNames(),
				dayNames = options.dayNames || defaultDayNames(),
				markupBlankDay = '<div class="m-d monthly-day-blank"><div class="monthly-day-number"></div></div>',
				weekStartsOnMonday = options.weekStart === "Mon" || options.weekStart === 1 || options.weekStart === "1",
				primaryLanguageCode = locale.substring(0, 2).toLowerCase();

		if (options.maxWidth !== false) {
			$(parent).css("maxWidth", options.maxWidth);
		}
		if (options.setWidth !== false) {
			$(parent).css("width", options.setWidth);
		}

		if (options.startHidden) {
			$(parent).addClass("monthly-pop").css({
				display: "none",
				position: "absolute"
			});
			$(document).on("focus", String(options.showTrigger), function (event) {
				$(parent).show();
				event.preventDefault();
			});
			$(document).on("click", String(options.showTrigger) + ", .monthly-pop", function (event) {
				event.stopPropagation();
				event.preventDefault();
			});
			$(document).on("click", function () {
				$(parent).hide();
			});
		}

		// Add Day Of Week Titles
		_appendDayNames(weekStartsOnMonday);
		var ajaxurl = myAjax.ajaxurl;;
		// Add CSS classes for the primary language and the locale. This allows for CSS-driven
		// overrides of the language-specific header buttons. Lowercased because locale codes
		// are case-insensitive but CSS is not.
		$(parent).addClass("monthly-locale-" + primaryLanguageCode + " monthly-locale-" + locale);

		// Add Header & event list markup
		$(parent).prepend('<div class="monthly-header"><div class="monthly-header-title"><a href="#" class="monthly-header-title-date" onclick="return false"></a></div><div class="monthly-selector"><select class="monthly-month-selector"></select><select class="monthly-year-selector"></select></div><a href="#" class="monthly-prev"></a><a href="#" class="monthly-next"></a></div>').append('<div class="monthly-event-list"></div>');

		// Set the calendar the first time

		if(cdate){
			let dateArray = cdate.split('-');
			setMonthly(parseInt(dateArray[1]), parseInt(dateArray[2]), parseInt(dateArray[0]));
		}else{
			setMonthly(currentMonth, currentYear);
		}

		// Initialize month and year selectors
		initializeMonthYearSelectors(currentMonth, currentYear);


		$('.daf-calendar__select span i').on('click', function (e){
			e.preventDefault();
			e.stopPropagation();
			let parent = $(this).parents('.daf-calendar__select');
			if(!parent.hasClass('active')) {
				$('.daf-calendar__select.active').not(parent).removeClass('active');
			}
			parent.hasClass('active') ? parent.removeClass('active') : parent.addClass('active');
		})

		// Close dropdown when clicking outside
		$(document).on('click', function(e) {
			if(!$(e.target).closest('.daf-calendar__select').length) {
				$('.daf-calendar__select.active').removeClass('active');
			}
			
			// Hide monthly-event-list when clicking outside the monthly container
			if(!$(e.target).closest(parent).length) {
				$(parent + ' .monthly-event-list').css('display', 'none');
			}
		})

		$('.daf-calendar__select span svg').on('click', function (e){
			e.preventDefault();
			let parent = $(this).parents('.daf-calendar__select');
			parent.attr('data-value', '');
			parent.find('span i').html(parent.attr('data-default'));
			parent.removeClass('selected').removeClass('active');
			$('.page-calendar').attr('data-full', '').attr('data-value', '').addClass('disabled');
			$('.page-calendar span i').html($('.page-calendar').attr('data-default'));
			checkSelect();
		})

		if ($('.daf-calendar__reset').length) {
			$('.daf-calendar__reset').on('click', function (e) {
				e.preventDefault();

				let masechetCalendar = $('.daf-calendar__select.masechet-calendar');
				masechetCalendar.attr('data-value', '');
				masechetCalendar.find('span i').html(masechetCalendar.attr('data-default'));
				masechetCalendar.removeClass('selected').removeClass('active');

				let pageCalendar = $('.page-calendar');
				pageCalendar.attr('data-full', '').attr('data-value', '').addClass('disabled');
				pageCalendar.find('span i').html(pageCalendar.attr('data-default'));

				let currentDate = new Date();
				let currentMonth = currentDate.getMonth() + 1;
				let currentYear = currentDate.getFullYear();
				let formatter = new Intl.DateTimeFormat(locale, {month: 'long'});
				let monthName = formatter.format(new Date(currentYear, currentMonth - 1, 1));
				let monthCalendar = $('.daf-calendar__select.month-calendar');

				monthCalendar.attr('data-value', currentMonth);
				monthCalendar.attr('data-full', monthName);
				monthCalendar.find('span i').html(monthName);
				monthCalendar.addClass('selected');

				let yearCalendar = $('.daf-calendar__select.year-calendar');
				yearCalendar.attr('data-value', currentYear);
				yearCalendar.attr('data-full', currentYear);
				yearCalendar.find('span i').html(currentYear);
				yearCalendar.addClass('selected');

				$('.masechet-calendar').attr('data-full', '');
				$('.page-calendar').attr('data-full', '');

				checkSelect();
			});
		}

		$('.daf-calendar__select--list').on('click', 'div', function (e){
			e.preventDefault();
			let parent = $(this).parents('.daf-calendar__select');
			parent.attr('data-value', $(this).attr('data-index'));
			parent.attr('data-full', $(this).text());
			parent.hasClass('active') ? parent.removeClass('active') : parent.addClass('active');
			parent.find('span i').html($(this).text());
			if(parent.hasClass('masechet-calendar')){
				$('.page-calendar').attr('data-full', '').attr('data-value', '').addClass('disabled');
				$('.page-calendar .daf-calendar__select--list').html();
				parent.addClass('selected');
			}
			if(parent.hasClass('month-calendar') || parent.hasClass('year-calendar')){
				$('.masechet-calendar, .page-calendar').attr('data-full', '').attr('data-value', '').removeClass('selected');
				$('.masechet-calendar span i').html($('.masechet-calendar').attr('data-default'));
				$('.page-calendar span i').html($('.page-calendar').attr('data-default'));
				$('.page-calendar').addClass('disabled');
			}
			checkSelect();
		})

		function checkSelect(){
			let monthCalendar = parseInt($('.month-calendar').attr('data-value'));
			let yearCalendar = parseInt($('.year-calendar').attr('data-value'));
			$('.daf-calendar__date').html($('.month-calendar').attr('data-full')+' '+$('.year-calendar').attr('data-full'));
			changeDate = true;
			setMonthly(monthCalendar, yearCalendar);
			
			// Update the month and year selectors in the calendar header
			updateMonthYearSelectors(monthCalendar, yearCalendar);
		}

		// How many days are in this month?
		function daysInMonth(month, year) {
			return month === 2 ? (year & 3) || (!(year % 25) && year & 15) ? 28 : 29 : 30 + (month + (month >> 3) & 1);
		}

		// Initialize month and year selectors
		function initializeMonthYearSelectors(currentMonth, currentYear) {
			// Populate month selector
			const monthSelector = $(parent).find('.monthly-month-selector');
			monthSelector.empty();
			
			for (let i = 0; i < 12; i++) {
				const monthName = monthNames[i];
				const monthValue = i + 1;
				const option = $('<option>', {
					value: monthValue,
					text: monthName,
					selected: monthValue === currentMonth
				});
				monthSelector.append(option);
			}
			
			// Populate year selector (5 years before and after current year)
			const yearSelector = $(parent).find('.monthly-year-selector');
			yearSelector.empty();
			
			const startYear = currentYear - 5;
			const endYear = currentYear + 5;
			
			for (let i = startYear; i <= endYear; i++) {
				const option = $('<option>', {
					value: i,
					text: i,
					selected: i === currentYear
				});
				yearSelector.append(option);
			}
			
			// Add event listeners
			monthSelector.on('change', function() {
				const selectedMonth = parseInt($(this).val());
				const selectedYear = parseInt(yearSelector.val());
				
				// Update the external month-calendar selector
				$('.month-calendar').attr('data-value', selectedMonth);
				$('.month-calendar').attr('data-full', monthNames[selectedMonth - 1]);
				$('.month-calendar span i').html(monthNames[selectedMonth - 1]);
				$('.month-calendar').addClass('selected');
				
				// Reset masechet and page selectors
				$('.masechet-calendar, .page-calendar').attr('data-full', '').attr('data-value', '').removeClass('selected');
				$('.masechet-calendar span i').html($('.masechet-calendar').attr('data-default'));
				$('.page-calendar span i').html($('.page-calendar').attr('data-default'));
				$('.page-calendar').addClass('disabled');
				
				// Update calendar
				changeDate = true;
				setMonthly(selectedMonth, selectedYear);
				
				// Update date display
				$('.daf-calendar__date').html($('.month-calendar').attr('data-full')+' '+$('.year-calendar').attr('data-full'));
			});
			
			yearSelector.on('change', function() {
				const selectedMonth = parseInt(monthSelector.val());
				const selectedYear = parseInt($(this).val());
				
				// Update the external year-calendar selector
				$('.year-calendar').attr('data-value', selectedYear);
				$('.year-calendar').attr('data-full', selectedYear);
				$('.year-calendar span i').html(selectedYear);
				$('.year-calendar').addClass('selected');
				
				// Reset masechet and page selectors
				$('.masechet-calendar, .page-calendar').attr('data-full', '').attr('data-value', '').removeClass('selected');
				$('.masechet-calendar span i').html($('.masechet-calendar').attr('data-default'));
				$('.page-calendar span i').html($('.page-calendar').attr('data-default'));
				$('.page-calendar').addClass('disabled');
				
				// Update calendar
				changeDate = true;
				setMonthly(selectedMonth, selectedYear);
				
				// Update date display
				$('.daf-calendar__date').html($('.month-calendar').attr('data-full')+' '+$('.year-calendar').attr('data-full'));
			});
		}
		
		// Update month and year selectors to match current view
		function updateMonthYearSelectors(month, year) {
			$(parent).find('.monthly-month-selector').val(month);
			$(parent).find('.monthly-year-selector').val(year);
		}

			function toHebrewNumber(num) {
				const hebrewNums = {
					1: "א", 2: "ב", 3: "ג", 4: "ד", 5: "ה",
					6: "ו", 7: "ז", 8: "ח", 9: "ט", 10: "י",
					11: "י״א", 12: "י״ב", 13: "י״ג", 14: "י״ד", 15: "ט״ו",
					16: "ט״ז", 17: "י״ז", 18: "י״ח", 19: "י״ט", 20: "כ",
					21: "כ״א", 22: "כ״ב", 23: "כ״ג", 24: "כ״ד", 25: "כ״ה",
					26: "כ״ו", 27: "כ״ז", 28: "כ״ח", 29: "כ״ט", 30: "ל",
					31: "ל״א"
				};
				return $('html').attr('lang') == "he-IL" ? hebrewNums[num] : num;
			}
		
		// Build the month
		function setMonthly(month, year, day = 0) {
			$(parent).data("setMonth", month).data("setYear", year);

			// Get number of days
			var index = 0,
				dayQty = daysInMonth(month, year),
				// Get day of the week the first day is
				mZeroed = month - 1,
				firstDay = new Date(year, mZeroed, 1, 0, 0, 0, 0).getDay(),
				settingCurrentMonth = month === currentMonth && year === currentYear;

			// Remove old days
			$(parent + " .monthly-day, " + parent + " .monthly-day-blank").remove();
			$(parent + " .monthly-event-list, " + parent + " .monthly-day-wrap").empty();
			// Print out the days
			for(var dayNumber = 1; dayNumber <= dayQty; dayNumber++) {
				// Check if it's a day in the past
				let activeDay = day == dayNumber ? 'activeDay' : '';
				var isInPast = options.stylePast && (
					year < currentYear
					|| (year === currentYear && (
						month < currentMonth
						|| (month === currentMonth && dayNumber < currentDay)
					))),
					innerMarkup = '<div class="monthly-day-number '+ activeDay +'">' + toHebrewNumber(dayNumber) + '</div><div class="monthly-indicator-wrap"></div>';
				if(options.mode === "event") {
					var thisDate = new Date(year, mZeroed, dayNumber, 0, 0, 0, 0);
					$(parent + " .monthly-day-wrap").append("<div"
						+ attr("class", "m-d "+ activeDay +" monthly-day monthly-day-event"
							+ (isInPast ? " monthly-past-day" : "")
							+ " dt" + thisDate.toISOString().slice(0, 10)
							)
						+ attr("data-number", dayNumber)
						+ ">" + innerMarkup + "</div>");
					$(parent + " .monthly-event-list").append("<div"
						+ attr("class", "monthly-list-item")
						+ attr("id", uniqueId + "day" + dayNumber)
						+ attr("data-number", dayNumber)
						+ '><div class="monthly-event-list-date">' + dayNames[thisDate.getDay()] + "<br>" + dayNumber + "</div></div>");
				} else {
					$(parent + " .monthly-day-wrap").append("<a"
						+ attr("href", "#")
						+ attr("class", "m-d monthly-day monthly-day-pick" + (isInPast ? " monthly-past-day" : "") + day == dayNumber ? "activeDay" : "")
						+ attr("data-number", dayNumber)
						+ ">" + innerMarkup + "</a>");
				}
			}

			if (settingCurrentMonth) {
				$(parent + ' *[data-number="' + currentDay + '"]').addClass("monthly-today");
			}

			// Update header title and selectors
			$(parent + " .monthly-header-title-date").html(monthNames[month - 1] + " " + year);
			
			// Update the month and year selectors
			updateMonthYearSelectors(month, year);
			
			// Add reset button if needed
			if (!(settingCurrentMonth && $(parent + " .monthly-event-list").hide()) && $(parent + " .monthly-reset").length === 0) {
				$(parent + " .monthly-header-title").append('<a href="#" class="monthly-reset"></a>');
			}

			// Account for empty days at start
			if(weekStartsOnMonday) {
				if (firstDay === 0) {
					_prependBlankDays(6);
				} else if (firstDay !== 1) {
					_prependBlankDays(firstDay - 1);
				}
			} else if(firstDay !== 7) {
				_prependBlankDays(firstDay);
			}

			// Account for empty days at end
			var numdays = $(parent + " .monthly-day").length,
				numempty = $(parent + " .monthly-day-blank").length,
				totaldays = numdays + numempty,
				roundup = Math.ceil(totaldays / 7) * 7,
				daysdiff = roundup - totaldays;
			if(totaldays % 7 !== 0) {
				for(index = 0; index < daysdiff; index++) {
					$(parent + " .monthly-day-wrap").append(markupBlankDay);
				}
			}

			// Events
			if (options.mode === "event") {
				addEvents(month, year, day);
			}
			var divs = $(parent + " .m-d");
			for(index = 0; index < divs.length; index += 7) {
				divs.slice(index, index + 7).wrapAll('<div class="monthly-week"></div>');
			}
		}

		function addEvent(event, setMonth, setYear, day = 0) {
			// Year [0]   Month [1]   Day [2]
			var fullStartDate = _getEventDetail(event, "startdate"),
				fullEndDate = _getEventDetail(event, "enddate"),
				startArr = fullStartDate.split("-"),
				startYear = parseInt(startArr[0], 10),
				startMonth = parseInt(startArr[1], 10),
				startDay = parseInt(startArr[2], 10),
				startDayNumber = startDay,
				endDayNumber = startDay,
				showEventTitleOnDay = startDay,
				startsThisMonth = startMonth === setMonth && startYear === setYear,
				happensThisMonth = startsThisMonth;

			if(fullEndDate) {
				// If event has an end date, determine if the range overlaps this month
				var	endArr = fullEndDate.split("-"),
					endYear = parseInt(endArr[0], 10),
					endMonth = parseInt(endArr[1], 10),
					endDay = parseInt(endArr[2], 10),
					startsInPastMonth = startYear < setYear || (startMonth < setMonth && startYear === setYear),
					endsThisMonth = endMonth === setMonth && endYear === setYear,
					endsInFutureMonth = endYear > setYear || (endMonth > setMonth && endYear === setYear);
				if(startsThisMonth || endsThisMonth || (startsInPastMonth && endsInFutureMonth)) {
					happensThisMonth = true;
					startDayNumber = startsThisMonth ? startDay : 1;
					endDayNumber = endsThisMonth ? endDay : daysInMonth(setMonth, setYear);
					showEventTitleOnDay = startsThisMonth ? startDayNumber : 1;
				}
			}
			if(!happensThisMonth) {
				return;
			}

			var startTime = _getEventDetail(event, "starttime"),
				timeHtml = "",
				eventURL = _getEventDetail(event, "url"),
				eventTitle = _getEventDetail(event, "name"),
				eventClass = _getEventDetail(event, "class"),
				eventColor = _getEventDetail(event, "color"),
				eventId = _getEventDetail(event, "id"),
				customClass = eventClass ? " " + eventClass : "",
				dayStartTag = "<div",
				dayEndTags = "</span></div>";

			if(startTime) {
				var endTime = _getEventDetail(event, "endtime");
				timeHtml = '<div><div class="monthly-list-time-start">20:00'+ "</div>"
					+ (endTime ? '' : "")
					+ "</div>";
			}

			if(options.linkCalendarToEventUrl && eventURL) {
				dayStartTag = "<a" + attr("href", eventURL);
				dayEndTags = "</span></a>";
			}

			var	markupDayStart = dayStartTag
					+ attr("data-eventid", eventId)
					+ attr("title", eventTitle)
					// BG and FG colors must match for left box shadow to create seamless link between dates
					+ (eventColor ? attr("style", "background:" + eventColor + ";color:" + eventColor) : ""),
				markupListEvent = "<a"
					+ attr("href", eventURL)
					+ attr("class", "listed-event" + customClass)
					+ attr("data-eventid", eventId)
					+ (eventColor ? attr("style", "background:" + eventColor) : "")
					+ attr("title", eventTitle)
					+ ">" + eventTitle + " " + timeHtml + "</a>";
			for(var index = startDayNumber; index <= endDayNumber; index++) {
				var doShowTitle = index === showEventTitleOnDay;
				// Add to calendar view
				$(parent + ' *[data-number="' + index + '"]').attr('href', eventURL);
				$(parent + ' *[data-number="' + index + '"] .monthly-indicator-wrap').append(
						markupDayStart
						+ attr("class", "monthly-event-indicator" + customClass
							// Include a class marking if this event continues from the previous day
							+ (doShowTitle ? "" : " monthly-event-continued")
							)
						+ "><span>" + (doShowTitle ? eventTitle : "") + dayEndTags);
				// Add to event list
				$(parent + ' .monthly-list-item[data-number="' + index + '"]')
					.addClass("item-has-event")
					.append(markupListEvent);
			}
		}

		function updateDefault(month, year){
			let monthText = $('.month-calendar .daf-calendar__select--list>div[data-index="' + month + '"]').text();
			$('.daf-calendar__loading').removeClass('active');
			$('.month-calendar').attr('data-value', month);
			$('.month-calendar span i').html(monthText);
			$('.year-calendar span i').html(year);
			$('.year-calendar').attr('data-value', year);
			$('.daf-calendar__date').html(monthText + ' ' + year);
			changeDate = false;
		}

		function addEvents(month, year, day= 0 ) {
			if(options.events) {
				$('.daf-calendar__loading').addClass('active');
				let masechet = $('.masechet-calendar').attr('data-full');
				let pagenumb = $('.page-calendar').attr('data-full');
				if($('.daf-calendar__loading').length > 0) {
					if(masechet && !pagenumb){
						$('.page-calendar .daf-calendar__select--list').html(' ');
						$.ajax({
							type: "POST",
							url: ajaxurl,
							data: {
								"action": "get_calendar_masechet_ajax",
								'masechet': masechet,
								'lang': $('html').attr('lang') == 'en-US' ? 'en' : 'he'
							},
							success: function (result) {
								let dayPage = day, monthPage = month, yearPage = year;
								changeDate = false;
								$('.page-calendar').addClass('disabled').attr('data-value', '').attr('data-full', '');
								$('.page-calendar span i').html($('.page-calendar').attr('data-default'));
								$('.page-calendar .daf-calendar__select--list').html(' ');
								let res = JSON.parse(result);
								if(res && res.length > 0){
									$('.page-calendar').removeClass('disabled');
									$.each(res, function(i, item) {
										$('<div data-index="'+item.page_number+'">'+item.page_number+'</div>').appendTo('.page-calendar .daf-calendar__select--list');
										if(i == 0){
											dayPage = parseInt(item.day);
											monthPage = parseInt(item.month);
											yearPage = parseInt(item.year);
										}
									});
								}
								options.events['monthly'] = res;
								updateDefault(monthPage, yearPage);
								addEventsFromString(options.events, monthPage, yearPage, day);
							}
						});
					}else if(pagenumb && masechet){
						$.ajax({
							type: "POST",
							url: ajaxurl,
							data: {
								"action": "get_calendar_masechet_ajax",
								'masechet': masechet,
								'pagenumb': pagenumb,
								'lang': $('html').attr('lang') == 'en-US' ? 'en' : 'he'
							},
							success: function (result) {
								changeDate = false;
								let res = JSON.parse(result);
								let dayPage = day, monthPage = month, yearPage = year;
								$.each(res, function(i, item) {
									if(item.page_number  == pagenumb){
										dayPage = parseInt(item.day);
										monthPage = parseInt(item.month);
										yearPage = parseInt(item.year);
									}
								});

								options.events['monthly'] = res;
								updateDefault(monthPage, yearPage);
								addEventsFromString(options.events, monthPage, yearPage, day);
								let top = $('.monthly-day[data-number="'+dayPage+'"]').offset().top;
								$('body,html').animate({scrollTop: top - 100}, 1000);
							}
						});
					}else {
						$.ajax({
							type: "POST",
							url: ajaxurl,
							data: {
								"action": "get_calendar_ajax",
								'startYear': year,
								'startMonth': month,
								'startDay': day,
								'lang': $('html').attr('lang') == 'en-US' ? 'en' : 'he'
							},
							success: function (result) {
								changeDate = false;
								allData = JSON.parse(result);
								updateDefault(month, year);
								options.events['monthly'] = JSON.parse(result);
								addEventsFromString(options.events, month, year, day);
							}
						});
					}
				}
			} else {
				var remoteUrl = options.dataType === "xml" ? options.xmlUrl : options.jsonUrl;
				if(remoteUrl) {
					// Replace variables for month and year to load from dynamic sources
					var url = String(remoteUrl).replace("{month}", month).replace("{year}", year);
					$.get(url, {now: $.now()}, function(data) {
						addEventsFromString(data, month, year);
					}, options.dataType).fail(function() {
						console.error("Monthly.js failed to import " + remoteUrl + ". Please check for the correct path and " + options.dataType + " syntax.");
					});
				}
			}
		}

		function addEventsFromString(events, setMonth, setYear, day = 0) {
			if (options.dataType === "xml") {
				$(events).find("event").each(function(index, event) {
					addEvent(event, setMonth, setYear, day);
				});
			} else if (options.dataType === "json") {
				$.each(events.monthly, function(index, event) {
					addEvent(event, setMonth, setYear, day);
				});
			}
		}

		function attr(name, value) {
			var parseValue = String(value);
			var newValue = "";
			for(var index = 0; index < parseValue.length; index++) {
				switch(parseValue[index]) {
					case "'": newValue += "&#39;"; break;
					case "\"": newValue += "&quot;"; break;
					case "<": newValue += "&lt;"; break;
					case ">": newValue += "&gt;"; break;
					default: newValue += parseValue[index];
				}
			}
			return " " + name + "=\"" + newValue + "\"";
		}

		function _appendDayNames(startOnMonday) {
			var offset = startOnMonday ? 1 : 0,
				dayName = "",
				dayIndex = 0;
			for(dayIndex = 0; dayIndex < 6; dayIndex++) {
				dayName += "<div>" + dayNames[dayIndex + offset] + "</div>";
			}
			dayName += "<div>" + dayNames[startOnMonday ? 0 : 6] + "</div>";
			$(parent).append('<div class="monthly-day-title-wrap">' + dayName + '</div><div class="monthly-day-wrap"></div>');
		}

		// Detect the user's preferred language
		function defaultLocale() {
			if(navigator.languages && navigator.languages.length) {
				return navigator.languages[0];
			}
			return navigator.language || navigator.browserLanguage;
		}

		// Use the user's locale if possible to obtain a list of short month names, falling back on English
		function defaultMonthNames() {
			if(typeof Intl === "undefined") {
				return ["Jan", "Feb", "Mar", "Apr", "May", "June", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
			}
			var formatter = new Intl.DateTimeFormat(locale, {month: monthNameFormat});
			var names = [];
			for(var monthIndex = 0; monthIndex < 12; monthIndex++) {
				var sampleDate = new Date(2017, monthIndex, 1, 0, 0, 0);
				names[monthIndex] = formatter.format(sampleDate);
			}
			return names;
		}

		function formatDate(year, month, day) {
			if(options.useIsoDateFormat) {
				return new Date(year, month - 1, day, 0, 0, 0).toISOString().substring(0, 10);
			}
			if(typeof Intl === "undefined") {
				return month + "/" + day + "/" + year;
			}
			return new Intl.DateTimeFormat(locale).format(new Date(year, month - 1, day, 0, 0, 0));
		}

		// Use the user's locale if possible to obtain a list of short weekday names, falling back on English
		function defaultDayNames() {
			if(typeof Intl === "undefined") {
				return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
			}
			var formatter = new Intl.DateTimeFormat(locale, {weekday: weekdayNameFormat}),
				names = [],
				dayIndex = 0,
				sampleDate = null;
			for(dayIndex = 0; dayIndex < 7; dayIndex++) {
				// 2017 starts on a Sunday, so use it to capture the locale's weekday names
				sampleDate = new Date(2017, 0, dayIndex + 1, 0, 0, 0);
				names[dayIndex] = formatter.format(sampleDate);
			}
			return names;
		}

		function _prependBlankDays(count) {
			var wrapperEl = $(parent + " .monthly-day-wrap"),
				index = 0;
			for(index = 0; index < count; index++) {
				wrapperEl.prepend(markupBlankDay);
			}
		}

		function _getEventDetail(event, nodeName) {
			return options.dataType === "xml" ? $(event).find(nodeName).text() : event[nodeName];
		}

		// Returns a 12-hour format hour/minute with period. Opportunity for future localization.
		function formatTime(value) {
			var timeSplit = value.split(":");
			var hour = parseInt(timeSplit[0], 10);
			var period = "AM";
			if(hour > 12) {
				hour -= 12;
				period = "PM";
			} else if (hour == 12) {
				period = "PM";
			} else if(hour === 0) {
				hour = 12;
			}
			return hour + ":" + String(timeSplit[1]) + " " + period;
		}

		function setNextMonth() {
			var	setMonth = $(parent).data("setMonth"),
				setYear = $(parent).data("setYear"),
				newMonth = setMonth === 12 ? 1 : setMonth + 1,
				newYear = setMonth === 12 ? setYear + 1 : setYear;
			changeDate = true;
			setMonthly(newMonth, newYear);
			viewToggleButton();
		}

		function setPreviousMonth() {
			var setMonth = $(parent).data("setMonth"),
				setYear = $(parent).data("setYear"),
				newMonth = setMonth === 1 ? 12 : setMonth - 1,
				newYear = setMonth === 1 ? setYear - 1 : setYear;
			changeDate = true;
			setMonthly(newMonth, newYear);
			viewToggleButton();
		}

		// Function to go back to the month view
		function viewToggleButton() {
			if($(parent + " .monthly-event-list").is(":visible")) {
				$(parent + " .monthly-cal").remove();
				$(parent + " .monthly-header-title").prepend('<a href="#" class="monthly-cal"></a>');
			}
		}

		// Function to update UI elements after month navigation
		function updateCalendarUI() {
			var currentMonth = $(parent).data("setMonth");
			var currentYear = $(parent).data("setYear");
			
			// Find the month name from the selector list
			var monthSelector = $(".month-calendar");
			var monthElement = monthSelector.find(".daf-calendar__select--list div[data-index='" + currentMonth + "']");
			var monthName = monthElement.length ? monthElement.text() : monthNames[currentMonth - 1];
			
			// Update the month selector
			monthSelector.attr("data-value", currentMonth)
				.attr("data-full", monthName)
				.addClass("selected")
				.find("span i").html(monthName);
			
			// Update the year selector
			$(".year-calendar").attr("data-value", currentYear)
				.attr("data-full", currentYear)
				.addClass("selected")
				.find("span i").html(currentYear);
			
			// Update the displayed date
			$(".daf-calendar__date").html(monthName + " " + currentYear);
			
			// Update the month and year selectors in the calendar header
			updateMonthYearSelectors(currentMonth, currentYear);
			
			// Reset masechet selection when changing months
			var masechetSelector = $(".masechet-calendar");
			if (masechetSelector.hasClass("selected")) {
				masechetSelector.attr("data-value", "")
					.attr("data-full", "")
					.removeClass("selected")
					.find("span i").html(masechetSelector.attr("data-default"));
				
				// Reset page selection
				var pageSelector = $(".page-calendar");
				pageSelector.attr("data-value", "")
					.attr("data-full", "")
					.addClass("disabled")
					.find("span i").html(pageSelector.attr("data-default"));
			}
		}

		// Advance months
		$(parent + " .monthly-next").on("click", function (event) {
			setNextMonth();
			event.preventDefault();
		});

		// Custom next month button in daf-calendar
		$(".daf-calendar__month-arrows .monthly-next").on("click", function (event) {
			setNextMonth();
			setTimeout(updateCalendarUI, 50);
			event.preventDefault();
		});

		// Go back in months
		$(parent + " .monthly-prev").on("click", function (event) {
			setPreviousMonth();
			event.preventDefault();
		});

		// Custom previous month button in daf-calendar
		$(".daf-calendar__month-arrows .monthly-prev").on("click", function (event) {
			setPreviousMonth();
			setTimeout(updateCalendarUI, 50);
			event.preventDefault();
		});

		// Reset Month
		$(document.body).on("click", parent + " .monthly-reset", function (event) {
			$(this).remove();
			setMonthly(currentMonth, currentYear);
			viewToggleButton();
			event.preventDefault();
			event.stopPropagation();
		});

		// Back to month view
		$(document.body).on("click", parent + " .monthly-cal", function (event) {
			$(this).remove();
			$(parent + " .monthly-event-list").css("transform", "scale(0)");
			setTimeout(function() {
				$(parent + " .monthly-event-list").hide();
			}, 250);
			event.preventDefault();
		});

		// Click A Day
		$(document.body).on("click touchstart", parent + " .monthly-day", function (event) {
			if($(window).width() > 768 && $(this).attr('href')) {
				window.location = $(this).attr('href');
			}else if(!$(this).attr('href')){

			}else{
				// If events, show events list
				var whichDay = $(this).data("number");
				if (options.mode === "event" && options.eventList) {
					var theList = $(parent + " .monthly-event-list"),
						myElement = document.getElementById(uniqueId + "day" + whichDay),
						topPos = myElement.offsetTop;
					theList.show();
					theList.css("transform");
					theList.css("transform", "scale(1)");
					$(parent + ' .monthly-list-item[data-number="' + whichDay + '"]').show();
					theList.scrollTop(topPos);
					viewToggleButton();
					if (!options.linkCalendarToEventUrl) {
						event.preventDefault();
					}
					// If picker, pick date
				} else if (options.mode === "picker") {
					var setMonth = $(parent).data("setMonth"),
						setYear = $(parent).data("setYear");
					// Should days in the past be disabled?
					if ($(this).hasClass("monthly-past-day") && options.disablePast) {
						// If so, don't do anything.
						event.preventDefault();
					} else {
						// Otherwise, select the date ...
						$(String(options.target)).val(formatDate(setYear, setMonth, whichDay));
						// ... and then hide the calendar if it started that way
						if (options.startHidden) {
							$(parent).hide();
						}
					}
					event.preventDefault();
				}
			}
		});

		// Clicking an event within the list
		$(document.body).on("click", parent + " .listed-event", function (event) {
			var href = $(this).attr("href");
			// If there isn't a link, don't go anywhere
			if(!href) {
				event.preventDefault();
			}
		});

		$(document.body).on("click", ".monthly-day-event", function (event) {
			if($(window).width() > 768) {}else {
				let day = $(this).attr('data-number');
				$('.monthly-event-list .monthly-list-item').removeClass('clicked');
				setTimeout(() => {
					let top = $('.monthly-event-list .monthly-list-item:nth-child(1)').height() + 16;
					let bodyTop = $('html').scrollTop();
					$('.monthly-event-list .monthly-list-item:nth-child(' + day + ')').addClass('clicked');
					if (day <= 4) {
						$('html').animate({scrollTop: 100}, 1000);
					} else {
						$('.monthly-event-list').animate({scrollTop: (top * day) - bodyTop}, 1000);
					}
				}, 300)
			}
		});


	}
	});
}(jQuery));
